<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      isChain: 'app/isChain',
    }),
  },
  created() {
    if (this.isChain === null) {
      this.checkRestoStatus();
    }
  },
  methods: {
    ...mapActions({
      checkRestoStatus: 'app/checkRestoStatus',
    }),
  },
};
</script>
